import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const RefreshIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <mask
                id="mask0_3169_137294"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_3169_137294)">
                <path
                    d="M11.757 19.9712C9.52362 19.9712 7.63196 19.1962 6.08196 17.6462C4.53196 16.0962 3.75696 14.2045 3.75696 11.9712C3.75696 9.73786 4.53196 7.84619 6.08196 6.29619C7.63196 4.74619 9.52362 3.97119 11.757 3.97119C12.907 3.97119 14.007 4.20886 15.057 4.68419C16.107 5.15886 17.007 5.83786 17.757 6.72119V4.97119C17.757 4.41891 18.2047 3.97119 18.757 3.97119C19.3092 3.97119 19.757 4.41891 19.757 4.97119V9.97119C19.757 10.5235 19.3092 10.9712 18.757 10.9712H13.757C13.2047 10.9712 12.757 10.5235 12.757 9.97119C12.757 9.41891 13.2047 8.97119 13.757 8.97119H16.957C16.4236 8.03786 15.6946 7.30452 14.77 6.77119C13.8446 6.23786 12.8403 5.97119 11.757 5.97119C10.0903 5.97119 8.67362 6.55452 7.50696 7.72119C6.34029 8.88786 5.75696 10.3045 5.75696 11.9712C5.75696 13.6379 6.34029 15.0545 7.50696 16.2212C8.67362 17.3879 10.0903 17.9712 11.757 17.9712C13.0403 17.9712 14.1986 17.6045 15.232 16.8712C16.073 16.2743 16.7098 15.5229 17.1423 14.6169C17.3224 14.2397 17.6872 13.9712 18.1051 13.9712C18.8134 13.9712 19.3322 14.646 19.0411 15.2918C18.5098 16.4704 17.7151 17.4718 16.657 18.2962C15.2236 19.4129 13.5903 19.9712 11.757 19.9712Z"
                    fill={color}
                />
            </g>
        </svg>
    );
};

export default React.memo(RefreshIcon);
